import { StepperOptions } from '@mydocma/import-export/lib/stepper/stepper.options';

export const reportStepperOptions: StepperOptions = {
  linear: false
};
